import React, { useMemo, useState } from "react";
import "./CompletedProjectsCard.css";
import { API_BASE_URL } from "../../utils/apiConfig";

export default function CompletedProjectsCard({
  projects = [],
  initialQuery = "",
  initialSort = "newest",
  showImages = true,
}) {
  const [query, setQuery] = useState(initialQuery);
  const [sort, setSort] = useState(initialSort);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    let list = projects.filter((p) => {
      if (!q) return true;
      return (
        p.client_name.toLowerCase().includes(q) ||
        (p.project_description || "").toLowerCase().includes(q) ||
        (JSON.parse(p.tech_stack) || []).join(" ").toLowerCase().includes(q)
      );
    });

    list.sort((a, b) => {
      const da = a.created_at ? new Date(a.created_at).getTime() : 0;
      const db = b.created_at ? new Date(b.created_at).getTime() : 0;
      if (sort === "newest") return db - da;
      if (sort === "oldest") return da - db;
      if (sort === "alpha") return a.title.localeCompare(b.title);
      return 0;
    });

    return list;
  }, [projects, query, sort]);

  const total = projects.length;

  return (
    <section className="completed-projects-container">
      <div className="completed-projects-card">
        <header className="completed-project-card-header">
          <div>
            <h2>Completed Milestones</h2>
            <p>A total of <span className="count">{total}</span> projects have been delivered successfully.</p>
          </div>

          <div className="completed-projects-controls">
            <input
              id="project-search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search title, description or tags..."
            />

            <select
              id="sort"
              value={sort}
              onChange={(e) => setSort(e.target.value)}
            >
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>
              <option value="alpha">A → Z</option>
            </select>
          </div>
        </header>

        <div className="completed-project-card-content">
          {filtered.length === 0 ? (
            <div className="no-results">No completed projects match your search.</div>
          ) : (
            <ul className="completed-projects-grid">
              {filtered.map((p) => (
                <li key={p.id} className="completed-project-item">
                  {showImages && p.image_url ? (
                    <div className="completed-project-image">
                      <img src={`${API_BASE_URL}/images/${p.image_url}`} alt={`Screenshot of ${p.project_name}`} />
                    </div>
                  ) : null}

                  <div className="completed-project-details">
                    <div>
                      <a href={"project/" + p.id} rel="noreferrer" className="completed-project-title">
                        {p.project_name}
                      </a>
                      <p className="completed-project-description">{p.project_description.split(" ").slice(0, 10).join(" ") + "..."}</p>

                      <div className="completed-project-tags">
                        {(JSON.parse(p.tech_stack) || []).slice(0, 6).map((t) => (
                          <span key={t} className="completed-project-tag">{t}</span>
                        ))}
                      </div>
                    </div>

                    <div className="completed-project-footer">
                      {/* <time dateTime={p.created_at || ""}>
                        {p.created_at ? new Date(p.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—'}
                      </time> */}

                      <div className="completed-project-links">
                        {/* {p.project_link && <a href={p.project_link} target="_blank" rel="noreferrer">Repo</a>} */}
                        {p.project_link && <a href={p.project_link} target="_blank" rel="noreferrer">Live Link</a>}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <footer className="completed-project-card-footer">
          Showing <span className="count">{filtered.length}</span> of <span className="count">{total}</span> completed projects
        </footer>
      </div>
    </section>
  );
}
